import React from "react";
import {
  Pagination,
  Datagrid,
  Tab,
  ReferenceManyField,
  TabbedShowLayout,
  BooleanField,
  Show,
  SimpleShowLayout,
  TextField
} from "react-admin";

const PersonShow = (props) => {
  return (
    <Show {...props}>
      <TabbedShowLayout>
        <Tab label="summary">
          <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="stableId" />
            <TextField source="name" />
            <BooleanField source="isStub" />
          </SimpleShowLayout>
        </Tab>
        <Tab label="team-seasons">
          <SimpleShowLayout>
            <ReferenceManyField
              reference="players"
              target="person_id"
              addLabel={false}
              pagination={<Pagination />}
              fullWidth
            >
              <Datagrid rowClick="show">
                <TextField source="id" />
                <TextField source="team.team.school.name" label="School" />
                <TextField source="team.sportCode" label="Sport" />
                <TextField source="team.seasonCode" label="Season" />
                <TextField source="yearCode" label="Year" />
                <TextField source="jerseyNumber" label="Jersey" />
                <TextField source="position" />
                <BooleanField source="isActive" />
              </Datagrid>
            </ReferenceManyField>
          </SimpleShowLayout>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default PersonShow;
